import { UPDATE_TERMS } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    terms: null,
};

const updateTerms = (state, action) => {
    return updateState(state, {
        terms: action.terms,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_TERMS:
            return updateTerms(state, action);
        default:
            return state;
    }
};

export default reducer;
